export const POSITIVE_CATEGORIZATION = 'PROS';
export const NEUTRAL_CATEGORIZATION = 'QUESTIONS';
export const NEGATIVE_CATEGORIZATION = 'LIMITS';
export const COMMENT_CATEGORIZATION_C = 'CLARIFICATION';
export const COMMENT_CATEGORIZATION_O = 'OPTION';
export const COMMENT_CATEGORIZATION_D = 'DEVELOPMENT';
export const COMMENT_CATEGORIZATION_E = 'EXPERIMENTATION';
export const CONTENT_DOWNLOAD_AUTHORIZED = true;
export const PRIVATE_ANALYSIS_DOCUMENT_TYPE = 'private';

export const FIRESTORE_COLLECTION_ANALYSES = 'analyses';
export const FIRESTORE_COLLECTION_REFLECTIONS = 'reflections';
export const FIRESTORE_COLLECTION_USER_PORTFOLIOS = 'userPortfolios';
export const FIRESTORE_COLLECTION_GROUP_PORTFOLIOS = 'groupPortfolios';
export const FIRESTORE_SUBCOLLECTION_USER_ANALYSES = 'userAnalyses';
export const FIRESTORE_SUBCOLLECTION_COMMENTS = 'analysisComments';

export const ACL_TYPE_GROUP = 'Group';
export const ACL_TYPE_USER = 'User';
